// extracted by mini-css-extract-plugin
export default {"button":"CyberpunkButton_button__zdle1","blink":"CyberpunkButton_blink__9a3zI"};